import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { TemplateDrawerContent } from 'app/domains/esigning/components/TemplateDrawer';
import { DefaultRecipientModal } from '../DefaultRecipientModal';
export function NoRecipientsState(props) {
    const { onAddRecipient } = props;
    const [renderDialog, setRenderDialog] = useState(false);
    const showDialog = () => setRenderDialog(true);
    const hideDialog = () => setRenderDialog(false);
    const handleSubmit = (recipient) => {
        onAddRecipient(recipient);
        hideDialog();
    };
    return (<Fragment>
      {renderDialog && <DefaultRecipientModal allRecipients={[]} onClose={hideDialog} onSubmit={handleSubmit}/>}
      <TemplateDrawerContent>
        <EmptyState withAvatar icon={<Falcon icon="pen-swirl"/>} title={t({
            comment: 'Manage template eSigning recipients - empty state - title',
            message: 'No recipients added',
        })} description={t({
            comment: 'Manage template eSigning recipients - empty state - description',
            message: 'All your default recipients will be listed here',
        })} actions={<Button size="small" appearance="primary" onClick={showDialog}>
              <Trans comment="Manage template eSigning recipients - empty state - add default recipient call to action label">
                Add recipient
              </Trans>
            </Button>}/>
      </TemplateDrawerContent>
    </Fragment>);
}
